import { render, staticRenderFns } from "./PageEventOrganizers.vue?vue&type=template&id=3184beaa&"
import script from "./PageEventOrganizers.vue?vue&type=script&lang=js&"
export * from "./PageEventOrganizers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3184beaa')) {
      api.createRecord('3184beaa', component.options)
    } else {
      api.reload('3184beaa', component.options)
    }
    module.hot.accept("./PageEventOrganizers.vue?vue&type=template&id=3184beaa&", function () {
      api.rerender('3184beaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/eventOrganizers/PageEventOrganizers.vue"
export default component.exports